import { useMemo } from 'react'
import { useModal } from '../../../../../hooks/useModal'
import { BUTTONS, IMAGE, TEXT, TITLE } from '../../../../modals/universalModal'
import { JANUARY_BONUS } from '../../../../../constants/events'
import { januaryBonusModal } from '../../../../../constants/copyright-modals'
import { useOnboarding } from '../../../../../redux/reducer/content'

export default function usePromoJanuaryBonusModal() {
  const { closeModal } = useModal()
  const { title, description, img } = januaryBonusModal

  const now = new Date()
  const start = new Date('2025-12-29T00:00:00')
  const end = new Date('2026-01-11T23:59:59')
  const isPromoPeriod = now >= start && now <= end
  const { eventModalsVisible } = useOnboarding()

  return useMemo(
    () =>
      eventModalsVisible &&
      isPromoPeriod && {
        id: 'januaryBonusModal',
        type: 'universalModal',
        event: JANUARY_BONUS,
        props: {
          modalProps: {
            wrapper: { isFullPage: false },
            modifier: ['noFullNoScroll', 'width-image-full'],
          },
          components: [
            {
              list: [
                {
                  type: IMAGE,
                  props: {
                    modifier: 'width-full',
                    img,
                  },
                },
                {
                  type: TITLE,
                  props: {
                    modifier: 'padding-no',
                    value: title,
                  },
                },
                {
                  type: TEXT,
                  props: {
                    value: description,
                  },
                },
                {
                  type: BUTTONS,
                  props: {
                    buttons: [
                      {
                        text: 'OK',
                        onClick: () => closeModal('all'),
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      },
    [isPromoPeriod, img, title, description, closeModal, eventModalsVisible],
  )
}
